var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { wasm, initAsync } from './utils/dbk_sign';
/**
 * @alias loadWasm
 */
export function lW(t) {
    return __awaiter(this, void 0, void 0, function* () {
        yield initAsync(t);
        return wasm;
    });
}
export { mkNW, makeSF, makeGsW, } from './sign-wasm.common';
